export const dataSettings = {
  valueField: 'value',
  textField: 'text',
};
